<template>
    <div>
        <div class="form-group">
            <div class="row row-gap-1rem">
                <div :class="filtersCount == 2 ? 'col-md-6 my-1' : 'col-12 my-1'">
                    <input
                    type="text"
                    name="search"
                    placeholder="Search ..."
                    class="form-control"
                    @keyup="handleSearch($event.target.value)"
                    >
                </div>

                <div v-if="accessCountries" :class="filtersCount < 4 ? 'col-md-6 my-1' : 'col-lg-4 my-1'">
                    <checkbox-input name="countries" label="Country" :items="countries" dimension="vertical" for-else-message="No countries available" @input="handleCountries" :checked="currentCountries"></checkbox-input>
                </div>

                <div v-if="! detail" :class="filtersCount < 4 ? 'col-lg-6 my-1': 'col-lg-4 my-1'">
                    <checkbox-input name="type_files" label="Type file" :items="typeFiles" dimension="vertical" for-else-message="No file types available" @input="handleTypeFiles" :checked="currentTypeFiles"></checkbox-input>
                </div>

                <div :class="filtersCount < 4 ? 'col-md-6 my-1' : 'col-lg-4 my-1'">
                    <checkbox-input name="brand_options" label="Brand" :items="brandOptions" dimension="vertical" for-else-message="No brands available" @input="handleBrandOptions" :checked="currentBrands"></checkbox-input>
                </div>
            </div>
        </div>

        <div v-if="loaded">
            <div v-if="files.length!=0">
                <div class="file-container">
                    <ul class="file-list">
                        <li v-for="file in files" :key="file.id" class="file-item rounded" @click="handleClick(file)">
                            <div class="file-thumb-container">
                                <div class="file-thumb" v-html="file.thumb"></div>
                            </div>
                            <div class="file-name mb-3" :title="file.name">{{ shortenString(file.name) }}</div>
                            <div v-if="accessCountries" class="mb-3">
                                <h5 v-if="file.country_description" class="text-info">{{ file.country_description }}</h5>
                                <h5 v-else>&nbsp;</h5>
                            </div>
                            <div class="mb-3">
                                <h5 v-if="file.type_file_description" class="text-info">{{ file.type_file_description }}</h5>
                                <h5 v-else>&nbsp;</h5>
                                <span v-if="file.number">{{ file.number }}</span>
                                <span v-else>&nbsp;</span>
                            </div>
                            <div  class="mb-3">
                                <h5 v-if="file.brands.length != 0" class="text-info">Brands</h5>
                                <h5 v-else>&nbsp;</h5>
                                <template v-if="file.brands.length != 0">
                                    <span v-for="brand, index in file.brands" :key="index">
                                        {{ brand.name }}<span v-if="index < file.brands.length - 1">, </span>
                                    </span>
                                </template>
                                <span v-else>&nbsp;</span>
                            </div>
                            <div v-if="isFileAlreadyAdded(file)" class="mt-auto mb-3"><mark class="bg-green text-white px-3 rounded">Added</mark></div>
                        </li>
                    </ul>
                </div>
                <div class="pagination" v-if="totalPages!=1">
                    <button class="btn btn-primary" @click.prevent="prevPage" :disabled="currentPage === 1">Previous</button>
                    <span>Page {{ currentPage }} of {{ totalPages }}</span>
                    <button class="btn btn-primary" @click.prevent="nextPage" :disabled="currentPage === totalPages">Next</button>
                </div>
            </div>
            <div v-else>
                <p class="text-info">No files available</p>
                <button class="btn btn-primary" @click.prevent="close">Close</button>
            </div>
        </div>
        <div v-else-if="error">
            <p class="text-danger"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ error }}</p>
            <button class="btn btn-primary" @click.prevent="close">Close</button>
        </div>
        <div v-else class="spinner-wrapper">
            <div class="spinner-border spinner-border-lg text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../../event-bus.js';
import CheckboxInput from '../Inputs/CheckboxInputCollapsible.vue';

export default {
    components: {
        CheckboxInput,
    },
    props: {
        attachmentType: { type:String, default:null, required:false },
        attachmentId: { type:Number, default:null, required:false },
        detail: { type:Boolean, default:false, required: false},
        alreadyAdded: { type:Array, default: () => [], required: false},
        searched: { type:String, required:true},
        brandOptions: { type:Array, required: true},
        typeFiles: { type:Array, required:true},
        countries: { type:Array, required:true},
        selectedTypeFiles:  { type:Array, required: true},
        selectedBrands: { type:Array, required: true},
        selectedCountries: { type:Array, required: true},
        agreementCountry: { type:Number, default:null, required:false},
        accessCountries: { type:Boolean, required:true}
    },
    computed: {
        filtersCount() {
            let count = 4;

            if(this.detail) {//no type filter
                count = count - 1;
            }

            if(! this.accessCountries) {//no countries filter
                count = count - 1;
            }

            return count;
        }
    },
    data() {
      return {
        files: [],
        currentPage: 1,
        totalPages: 1,
        itemsPerPage: 50,
        loaded: false,
        error: null,
        currentCountries: [],
        currentTypeFiles: [],
        currentBrands: [],
        currentSearch: '',
        searchTimeout: null,
      };
    },
    created() {
        if(this.agreementCountry) {
            this.currentCountries.push(this.agreementCountry);
        }

        this.getFiles();
    },
    methods: {
        shortenString(string, length = 20) {
            if (string && string.length > length) {
                return string.substring(0, length) + '...';
            }

            return string;
        },
        isFileAlreadyAdded(file) {
            return this.alreadyAdded.includes(file.id) && !this.detail;
        },
        reloadPage(name) {
            const currentPath = window.location.pathname;
            const origin = window.location.origin;
            const url = new URL(origin + currentPath);

            url.searchParams.set('name', name);
            url.searchParams.set('status', 'added');

            url.searchParams.set('search', this.searched);
            this.selectedCountries.forEach(value => url.searchParams.append('select_country[]', value));
            this.selectedTypeFiles.forEach(value => url.searchParams.append('select_type_file[]', value));
            this.selectedBrands.forEach(value => url.searchParams.append('select_brand[]', value));

            const href = url.toString();

            window.location.href = href;
        },
        handleCountries(values) {
            this.currentCountries = values;

            this.getFiles();
        },
        handleTypeFiles(values) {
            this.currentTypeFiles = values;

            this.getFiles();
        },
        handleBrandOptions(values) {
            this.currentBrands = values;

            this.getFiles();
        },
        handleSearch(value) {
            // Trigger search only after user stops typing
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.currentSearch = value;
                this.getFiles();
            }, 500);
        },
        async getFiles() {
            try {
                this.loaded = false;
                var params = {
                    page: this.currentPage,
                    limit: this.itemsPerPage,
                    detail: this.detail ? '1' : '0',
                    search: this.currentSearch,
                    countries: this.currentCountries,
                    type_files: this.currentTypeFiles,
                    brands: this.currentBrands,
                }
                const response = await axios.get('/api/get-document-list',  { params, paramsSerializer: (params) => {
                    return qs.stringify(params);
                }});
                this.loaded = true;
                const paging = response.data.paging;
                this.files = paging.data;
                this.totalPages = paging.last_page;
            } catch (error) {
                this.error = 'Failed to load files';
            }
        },
        async handleClick(file) {
            try {
                if(this.detail) {
                    EventBus.$emit('detailFileChanged', file);
                    this.close();

                    return;
                }

                const params =  {
                    attachment_id: this.attachmentId,
                    attachment_type: this.attachmentType,
                    document_id: file.id,
                };

                const response = await axios.post('/api/save-selected-document', params);
                this.reloadPage(response.data.document.name);

                this.close();
            } catch (error) {
                this.error = 'Failed to save selected file';
            }
        },
        close() {
            this.$emit('close');
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                this.getFiles();
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.getFiles();
            }
        }
    }
  };
  </script>

  <style scoped>
    .pagination {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
    }
    .spinner-wrapper {
        text-align: center;
    }
    .file-container {
        height: 440px;
        overflow-y: scroll;
        width: 100%;
        scrollbar-width: thin;
        font-size: .8rem;
    }
    .file-container h5 {
        font-size: 1rem;
        margin-bottom: .2rem;
    }
    .file-list {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 20px;
        list-style-type: none;
        padding: 0;
        margin: 0;
    }
    .file-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        border: 1px solid #ccc;
        padding: 1rem 1rem 0 1rem;
        box-sizing: border-box;
        cursor: pointer;
    }
    .file-item:hover {
        border: 1px solid #000;
    }
    .file-thumb-container {
        flex: none;
        width:120px;
        height:120px;
        display:flex;
        align-items:center;
        justify-content:center;
        margin-bottom: 10px;
    }
    .file-thumb {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    ::v-deep .file-thumb img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }
    ::v-deep .file-thumb .fa {
        font-size: 4em;
    }
    .file-name {
        font-size: 14px;
        color: #333;
        width: 100%;
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-all;
    }
    .mt-auto {
        margin-top: auto;
    }
    @media screen and (max-width: 1199px) {
        .file-list {
            grid-template-columns: repeat(4, 1fr);
        }
    }
    @media screen and (max-width: 991px) {
        .file-list {
            grid-template-columns: repeat(3, 1fr);
        }
    }
    @media screen and (max-width: 767px) {
        .file-list {
            grid-template-columns: repeat(2, 1fr);
        }
    }
</style>